var childrenRootLegacy = 'fx_c76f37be_1fza2i10';
var scrollAreaRootLegacy = 'fx_c76f37be_1fza2i11';
var scrollAreaViewportLegacy = 'fx_c76f37be_1fza2i15';
var scrollAreaViewportLegacyPaddingBottom = 'var(--fx_c76f37be_1fza2i14)';
var scrollAreaViewportLegacyPaddingTop = 'var(--fx_c76f37be_1fza2i13)';
var scrollbarMarginTop = 'var(--fx_c76f37be_1fza2i12)';

export { childrenRootLegacy, scrollAreaRootLegacy, scrollAreaViewportLegacy, scrollAreaViewportLegacyPaddingBottom, scrollAreaViewportLegacyPaddingTop, scrollbarMarginTop };
//# sourceMappingURL=scrollAreaLegacy.vanilla.mjs.map
